// 🔧 scan_types.js
// ✅ Purpose: Central registry of LGV scanner payload types
// ✅ Features:
// - Standardizes supported scanner types
// - Keeps QR scanning reusable across Passport, Voting, Tickets, Vendors, Sponsors, and future modules
// - Prevents hardcoded scan type strings across the app

export const SCAN_TYPES = {
  PASSPORT: "passport",
  VOTE: "vote",
  TICKET: "ticket",
  AUCTION: "auction",
  VOLUNTEER: "volunteer",
  USER: "user",
  VENDOR: "vendor",
  SPONSOR: "sponsor",
  UNKNOWN: "unknown",
};